import { Component, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { PageLayoutComponent } from 'app/base-component/page-layout/page-layout.component';
import { LoadingComponent } from 'app/sharedComponent/main-component/loading/loading.component';
import { ManageAccess, Service } from 'app/util/manage-access';
import { LoadingService } from 'app/services/utilities/loading.service';

@Component({
    standalone: true,
    selector: 'app-hub',
    templateUrl: './hub.component.html',
    styleUrls: ['./hub.component.scss'],
    imports: [MatCardModule, PageLayoutComponent, LoadingComponent, TranslateModule, MatIconModule]
})
export class HubComponent {
    loadingService: LoadingService = inject(LoadingService);
    manageAccessService: ManageAccess = inject(ManageAccess);
    service = Service;
}
